export default __webpack_public_path__ + "static/media/4.458728e0.png";